import axios from 'axios';
import * as yup from 'yup';
const responseSchema = yup
    .object()
    .camelCase()
    .required()
    .shape({
    message: yup.string().required().oneOf(['OK']),
});
export async function logHubView({ patientId, }) {
    const url = '/api/report/logHubView';
    const response = await axios.post(url, {
        patient_id: patientId,
    });
    const { message } = await responseSchema.validate(response.data);
    return {
        message,
    };
}
